"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _CampaignDetailsPage = babelHelpers.interopRequireDefault(require("components/CampaignDetailsPage"));

var _decorators = require("decorators");

var _Overview = require("tab/Overview");

var _PeopleBlockList = babelHelpers.interopRequireDefault(require("components/PeopleBlockList"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var CampaignOverviewTab = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CampaignOverviewTab, _Component);

  function CampaignOverviewTab() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CampaignOverviewTab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CampaignOverviewTab)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "details", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "discussion", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "showDiscussion", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CampaignOverviewTab, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "objectBodyTab container"
      }, _react.default.createElement("div", {
        className: "campaignDetailPageContent"
      }, _react.default.createElement(_CampaignDetailsPage.default, this.details)), this.showDiscussion ? this.discussion && _react.default.createElement(_Overview.OverviewDiscussionTab, this.discussion) : this.discussion && _react.default.createElement("div", {
        style: {
          display: 'none'
        }
      }, _react.default.createElement(_Overview.OverviewDiscussionTab, this.discussion)));
    }
  }]);
  return CampaignOverviewTab;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "details", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showDiscussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = CampaignOverviewTab;